import {stage} from '../../../../config/stage';

// key in flexi-marketplace-dev sandbox
const stripeConfig = {
    prod: {
        publishableKey: 'pk_test_51PCp2pHFN7HgbQ5GfapDnzS4pYfysrTjegKneBwkpvmzdeN9K5wTmTVRPCPdfqV3Jsb3ZETrm1daP4zGasMTgR370006YIUiXr',
    },
    test: {
        publishableKey: 'pk_test_51PCp2pHFN7HgbQ5GfapDnzS4pYfysrTjegKneBwkpvmzdeN9K5wTmTVRPCPdfqV3Jsb3ZETrm1daP4zGasMTgR370006YIUiXr',
    },
    dev: {
        publishableKey: 'pk_test_51PCp2pHFN7HgbQ5GfapDnzS4pYfysrTjegKneBwkpvmzdeN9K5wTmTVRPCPdfqV3Jsb3ZETrm1daP4zGasMTgR370006YIUiXr',
    },
    ide: {
        publishableKey: 'pk_test_51PCp2pHFN7HgbQ5GfapDnzS4pYfysrTjegKneBwkpvmzdeN9K5wTmTVRPCPdfqV3Jsb3ZETrm1daP4zGasMTgR370006YIUiXr',
    },
};


export const stripePublishableKey = stripeConfig[stage].publishableKey;

export const stripeOptions = {
    mode: 'payment' as const,
    currency: 'usd',
    appearance: {
        theme: 'stripe' as const,
    },
};


